if (!customElements.get('ux-buy-block')) {
  class UxBuyBlock extends HTMLElement {
    connectedCallback() {
      this.priceEls = Array.from(this.querySelectorAll('[data-uxbb-price]'));
      const sticky = document.querySelector(
        `ux-sticky-bar[data-target-id="ProductSubmitButton-${this.closest('[data-section-id]')?.dataset.sectionId || ''}"]`
      );
      if (sticky) {
        this.priceEls = this.priceEls.concat(Array.from(sticky.querySelectorAll('[data-uxbb-price]')));
      }
      if (!this.priceEls.length) return;

      const ref = this.priceEls[0];
      this.baseCents = parseInt(ref.dataset.baseCents, 10);
      if (Number.isNaN(this.baseCents) || this.baseCents <= 0) return;

      this.initialText = ref.textContent.trim();
      const numberMatch = this.initialText.match(/[\d,]+\.?\d*/);
      if (!numberMatch) return;

      const form = this.querySelector('form[data-type="add-to-cart-form"]');
      const qtyInput =
        form?.elements.namedItem('quantity') ||
        document.querySelector('input[name="quantity"]');
      if (!qtyInput) return;

      this.qtyInput = qtyInput;
      this.sectionId = this.closest('[data-section-id]')?.dataset.sectionId || '';
      this.overridePriceCents = null;

      this.onCfPrice = (e) => {
        if (!e || !e.detail) return;
        if (e.detail.sectionId && this.sectionId && String(e.detail.sectionId) !== String(this.sectionId)) return;
        const cents = parseInt(e.detail.priceCents, 10);
        if (!Number.isFinite(cents) || cents < 0) return;
        this.overridePriceCents = cents;
        this.update();
      };
      document.addEventListener('cf:price-change', this.onCfPrice);

      this.update();
      qtyInput.addEventListener('change', () => this.update());
      qtyInput.addEventListener('input', () => this.update());
    }

    update() {
      const qty = parseInt(this.qtyInput.value, 10) || 1;
      const totalCents = this.overridePriceCents != null ? this.overridePriceCents : this.baseCents * qty;
      const totalNumber = totalCents / 100;
      const formatted = totalNumber.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      const newText = this.initialText.replace(/[\d,]+\.?\d*/, formatted);
      this.priceEls.forEach((el) => {
        el.textContent = newText;
      });
    }

    disconnectedCallback() {
      if (this.onCfPrice) document.removeEventListener('cf:price-change', this.onCfPrice);
    }
  }

  customElements.define('ux-buy-block', UxBuyBlock);
}

if (!customElements.get('ux-sticky-bar')) {
  class UxStickyBar extends HTMLElement {
    connectedCallback() {
      const targetId = this.dataset.targetId;
      if (!targetId) return;

      this.target = document.getElementById(targetId);
      if (!this.target) return;

      // Portal to <body> so any transformed ancestor (Shopify view transitions,
      // animations, contain:paint) can't break position:fixed.
      if (this.parentElement !== document.body) {
        this._originalParent = this.parentElement;
        document.body.appendChild(this);
      }

      this.trigger = this.querySelector('[data-uxbb-sticky-trigger]');
      this.trigger?.addEventListener('click', this.onTriggerClick.bind(this));

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.remove('is-shown');
              this.setAttribute('aria-hidden', 'true');
            } else {
              this.classList.add('is-shown');
              this.setAttribute('aria-hidden', 'false');
            }
          });
        },
        { rootMargin: '0px', threshold: 0 }
      );

      this.observer.observe(this.target);
    }

    onTriggerClick(event) {
      event.preventDefault();
      if (!this.target || this.target.disabled) return;
      this.target.click();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('ux-sticky-bar', UxStickyBar);
}
